var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcxStaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2960_6007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 0.5H18.2857C19.4078 0.5 20.3174 1.40964 20.3174 2.53175C20.3174 3.65385 19.4078 4.56349 18.2857 4.56349H16.2539V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 8.62695H26.4126C27.5347 8.62695 28.4444 9.53659 28.4444 10.6587C28.4444 11.7808 27.5347 12.6904 26.4126 12.6904H16.2539V8.62695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 24.8809H22.3491C23.4713 24.8809 24.3809 25.7905 24.3809 26.9126C24.3809 28.0346 23.4713 28.9444 22.3491 28.9444H16.2539V24.8809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 16.7539H30.4761C31.5982 16.7539 32.5079 17.6635 32.5079 18.7857C32.5079 19.9078 31.5982 20.8174 30.4761 20.8174H16.2539V16.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 8.62697H10.1587C9.03659 8.62697 8.12695 7.71733 8.12695 6.59522C8.12695 5.47311 9.03659 4.56348 10.1587 4.56348H16.2539V8.62697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.254 16.7539H2.03175C0.909643 16.7539 0 15.8443 0 14.7222C0 13.6001 0.909643 12.6904 2.03175 12.6904H16.254V16.7539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2549 24.8809H6.0962C4.97409 24.8809 4.06445 23.9712 4.06445 22.8491C4.06445 21.727 4.97409 20.8174 6.0962 20.8174H16.2549V24.8809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2549 32.4999H13.9692C12.9873 32.4999 12.1914 31.704 12.1914 30.7221C12.1914 29.7403 12.9873 28.9443 13.9692 28.9443H16.2549V32.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2960_6007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5079,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcxStaricon);
export default __webpack_public_path__ + "static/media/ncx-staricon.00b41b5eb52e1b0d1d826bd826831c25.svg";
export { ForwardRef as ReactComponent };